// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"09376b6e","767":"37de83a6"}[chunkId] + ".chunk.js";
};